import React            from "react"
import {useTranslation} from "react-i18next"

import {IonItemDivider, IonItemGroup} from "@ionic/react"

import {SyncCollectionItem, SyncCollections} from "../../../types/SyncCollections"
import LockingSystem                         from "../../../types/LockingSystem"
import {useLockingSystems} from "../../../contexts/LockingSystemContext"
import ButtonSync          from "./ButtonSync"
import CollectionsListItem from "./CollectionsListItem"

interface componentProps {
    item: LockingSystem
}

const CollectionsList: React.FC<componentProps> = ({item}) => {

    const { t } = useTranslation()

    const {
        changeSelectedItemId,
        hasFeature: hasLockingSystemFeature,
        isSynchronizing
    } = useLockingSystems()

    const syncElement = (collectionItem: SyncCollectionItem) => {
        return <ButtonSync collectionItem={collectionItem} lockingSystemItem={item} />
    }

    return (
        <IonItemGroup key={'locking-system-' + item.id + '-view-linked'}>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            {SyncCollections.map((collectionItem: SyncCollectionItem, index) => {

                if (collectionItem.needsFeature) {
                    if (! hasLockingSystemFeature(collectionItem.needsFeature)) {
                        return (<div key={index}></div>)
                    }
                }

                return (
                    <CollectionsListItem key={item.id + '-' + collectionItem.key} item={item}
                                         changeSelectedItemId={changeSelectedItemId}
                                         collectionItem={collectionItem}
                                         isSynchronizing={isSynchronizing}
                                         syncElement={syncElement} />
                )
            })}
        </IonItemGroup>
    )
}

export default CollectionsList